import { render, staticRenderFns } from "./TeachersEditTabAccount.vue?vue&type=template&id=2998a95d"
import script from "./TeachersEditTabAccount.vue?vue&type=script&lang=js"
export * from "./TeachersEditTabAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports